import type { AccountRow } from './account-tree.ts'
import type { Snapshot } from '@taler/api-client'

/** Only a postable, non-system ASSET or LIABILITY account with a currency has a single
 * real-world balance a bank or wallet statement can be compared against. */
export function isReconcilableAccount(row: AccountRow): boolean {
  return (
    row.isPostable &&
    !row.isSystem &&
    !row.isArchived &&
    (row.accountClass === 'ASSET' || row.accountClass === 'LIABILITY') &&
    row.currency !== undefined
  )
}

export type SnapshotOutcome = 'matched' | 'corrected' | 'reversed'

/** A snapshot with no correcting entry needed no correction - a good outcome, not an empty
 * one. One whose correcting entry was later reversed no longer reflects the books. */
export function snapshotOutcome(snapshot: Snapshot): SnapshotOutcome {
  if (snapshot.correctingEntryId === undefined) return 'matched'
  return snapshot.correctingEntryReversedAt === undefined ? 'corrected' : 'reversed'
}
